import { jobStatuses, type JobInsertSchema } from "@adva/types";
import {
  enumOptions,
  type EntityFieldConfig,
} from "@/components/v2/entity-form-config";

export type JobFormValues = (typeof JobInsertSchema)["_output"];

export function jobFields(
  customerOptions: { value: string; label: string }[],
): EntityFieldConfig<JobFormValues>[] {
  return [
    {
      name: "contact_role_id",
      label: "Customer",
      control: "select",
      required: true,
      options: customerOptions,
      emptyOptionLabel: "Select customer",
    },
    {
      name: "job_number",
      label: "Job number",
      control: "text",
      required: true,
    },
    { name: "name", label: "Name", control: "text" },
    {
      name: "status",
      label: "Status",
      control: "select",
      options: enumOptions(jobStatuses),
    },
    { name: "notes", label: "Notes", control: "textarea" },
  ];
}

export function jobToFormValues(
  j: Record<string, unknown> | undefined,
): Partial<JobFormValues> {
  if (!j) return {};
  const str = (v: unknown): string | undefined =>
    typeof v === "string" && v.length > 0 ? v : undefined;
  return {
    contact_role_id: str(j.contact_role_id),
    job_number: str(j.job_number),
    name: str(j.name),
    status: (str(j.status) as JobFormValues["status"]) ?? "new",
    notes: str(j.notes),
  };
}
